import React from "react";
import chesssboard from "../images/chesssboard.png";
import chessslogo from "../images/chessslogo.png";

function PuzzleSummary() {
  return (
   
            <div className="" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>  
              <div style={{ 
          color: 'aquamarine', 
          fontSize: '24px', 
          fontWeight: 'bold', 
          textAlign: 'center', 
          padding: '4px', 
          borderBottom: '2px solid aquamarine',
          marginBottom: '20px'
        }}>P U Z Z L E S</div>
              <div style={{ 
          color: 'white', 
          width: '80%', 
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start', // Align list items properly
          justifyContent: 'flex-start',
          marginLeft: '0px',
          gap: '5px'
        }}>
              <li>Board Is Interactive</li>
              <li>Click Outside The <span style={{ paddingLeft: '23px' }}>Board To Expand</span><span style={{ paddingLeft: '23px' }}> The Puzzle Further</span></li>
              </div>
              <img src={chessslogo} alt="Chess Logo" style={{ width: '150px', height: '150px', marginTop: 'auto', marginBottom: '10px' }} />
              <div style={{ color: 'aquamarine', fontSize: '20px', fontWeight: 'bold', textAlign: 'center', marginBottom: '10px' }}>Speed Puzzle<br />Mini-Game<br />Coming Soon!</div>
              {/* <button 
                className="trending-cta-2" 
                style={{ 
                  background: '', 
                  lineHeight: '1.5', 
                  marginTop: 'auto', 
                  marginBottom: '10px', 
                  width: '90%', 
                  height: '80px', 
                  padding: '10px', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onClick={() => {
                  window.location.href = '/analysis';
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#b8860b';
                  e.currentTarget.style.borderColor = 'gold';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = '';
                  e.currentTarget.style.borderColor = '';
                  e.currentTarget.style.color = '';
                }}
              >C R E A T O R S<br />S T A R T&nbsp;&nbsp;&nbsp;H E R E</button> */}
        </div>
  );
}

export default PuzzleSummary;